import * as Types from '@frameio/graphql-client/generated/types';

import { TypedDocumentNode as DocumentNode } from '@graphql-typed-document-node/core';
import gql from 'graphql-tag';

import { useQuery, useLazyQuery, useMutation, useFragment, useSubscription } from '@apollo/client';
import type { QueryHookOptions, LazyQueryHookOptions, MutationHookOptions, SubscriptionHookOptions, UseFragmentOptions } from '@apollo/client';

export type RemoveExportMetadataMutationVariables = Types.Exact<{
  assetId: Types.Scalars['ID']['input'];
  sequenceId?: Types.InputMaybe<Types.Scalars['ID']['input']>;
}>;


export type RemoveExportMetadataMutation = { __typename?: 'Mutation', removeExportMetadata: Array<{ __typename?: 'PremiereSequence', id?: string | null } | null> };


export const RemoveExportMetadata = /*#__PURE__*/ gql`
    mutation RemoveExportMetadata($assetId: ID!, $sequenceId: ID) {
  removeExportMetadata(assetId: $assetId, sequenceId: $sequenceId) {
    id
  }
}
    ` as unknown as DocumentNode<RemoveExportMetadataMutation, RemoveExportMetadataMutationVariables>;

          

          export const useRemoveExportMetadataMutation = (options?:MutationHookOptions<RemoveExportMetadataMutation, RemoveExportMetadataMutationVariables>) => useMutation(RemoveExportMetadata, options);
          

          export type RemoveExportMetadataMutationOptions = MutationHookOptions<RemoveExportMetadataMutation, RemoveExportMetadataMutationVariables>;

          

          export type RemoveExportMetadataMutationResult = ReturnType<typeof useRemoveExportMetadataMutation>[1];

          
